<template>
    <div class="hkqk-view">
        <HeaderNav
            header-title="回款情况"
            left-icon-name="2"
            right-icon-name="2"
            @change-org="getNewOrgId"
        ></HeaderNav>
        <div @click="showPickerTime = true" class="head-title-tips">
            <span class="iconfont iconrili"></span>
            <span>{{ selectTimeYear }}年{{ selectTimeMonth }}月份，中国联合水泥商混业务产销概况</span>
        </div>
        <div
            class="picker-content"
            v-show="showPickerTime"
        >
            <van-datetime-picker
                v-model="currentDate"
                :max-date="maxDate"
                type="year-month"
                @confirm="selectTime"
                @cancel="showPickerTime = false"
            ></van-datetime-picker>
        </div>
        <div class="money-back-box">
            <div class="mobile-one">
                <div class="mobile-one-title">
                    <p>本月回款:<span>{{ totalMonth | toFixedNumber }}万元</span></p>
                    <p
                        @click="showChars"
                    >
                        年累计货款回收率:{{ daikuanVal | toFixedNumber }}%
                    </p>
                </div>
                <!-- 图表1 -->
                <div id="main"></div>
                <div class="mobild-one-bottom">
                    <div>
                        <p>{{ jhwcl | toFixedNumber }}%</p>
                        <span>计划完成率</span>
                    </div>
                    <h5 class="shu"></h5>
                    <div>
                        <p>{{ bnljhk | toFixedNumber }}</p>
                        <span>本年累计回款(万元)</span>
                    </div>
                    <h5 class="shu"></h5>
                    <div>
                        <p>{{ bnjhhk | toFixedNumber }}</p>
                        <span>本年计划回款(万元)</span>
                    </div>
                </div>
            </div>
            <div class="mobile-two">
                <h2>应收账款 <span>单位:(万元)</span></h2>
                <div class="big-block">
                    <div class="color-block">
                        <p>{{ (totalInfoData.pay_balance_reduce || 0) | toFixedNumber }}</p>
                        <span>减少</span>
                        <h3></h3>
                    </div>
                    <div class="color-block">
                        <p>{{ (totalInfoData.pay_balance_begin || 0) | toFixedNumber }}</p>
                        <span>期初</span>
                        <h3></h3>
                    </div>
                    <div class="color-block">
                        <p>{{ (totalInfoData.pay_balance_end || 0) | toFixedNumber }}</p>
                        <span>期末</span>
                        <h3></h3>
                    </div>
                </div>
            </div>
            <div class="mobile-two">
                <h2>预收账款 <span>单位:(万元)</span></h2>
                <div class="big-block">
                    <div class="color-block">
                        <p>{{ yszkjs }}</p>
                        <span>减少</span>
                        <h3></h3>
                    </div>
                    <div class="color-block">
                        <p>{{ (totalInfoData.advance_begin || 0) | toFixedNumber }}</p>
                        <span>期初</span>
                        <h3></h3>
                    </div>
                    <div class="color-block">
                        <p>{{ (totalInfoData.advance_end || 0) | toFixedNumber }}</p>
                        <span>期末</span>
                        <h3></h3>
                    </div>
                </div>
            </div>
            <div class="mobile-three">
                <h2>账龄 <span>单位:(万元)</span></h2>
                <div class="mobild-three-content">
                    <div class="mobile-content">
                        <span>0-1年(含)</span>
                        <p class="green-color">
                            {{ totalInfoData.accountage_0 | toFixedNumber }}
                        </p>
                    </div>
                    <div class="mobile-content">
                        <span>1-2年(含)</span>
                        <p class="origin-color">
                            {{ totalInfoData.accountage_1 | toFixedNumber }}
                        </p>
                    </div>
                    <div class="mobile-content">
                        <span>2-3年(含)</span>
                        <p class="blue-color">
                            {{ totalInfoData.accountage_2 | toFixedNumber }}
                        </p>
                    </div>
                    <div class="mobile-content">
                        <span>3-4年(含)</span>
                        <p class="green-color">
                            {{ totalInfoData.accountage_3 | toFixedNumber }}
                        </p>
                    </div>
                    <div class="mobile-content">
                        <span>4-5年(含)</span>
                        <p class="origin-color">
                            {{ totalInfoData.accountage_4 | toFixedNumber }}
                        </p>
                    </div>
                    <div class="mobile-content">
                        <span>5年以上</span>
                        <p class="blue-color">
                            {{ totalInfoData.accountage_5 | toFixedNumber }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="alert-chart" v-show="showAlert">
                <div class="chart-content">
                    <div class="content-title">
                        <span class="iconfont"></span>
                        <span class="title-center">每月贷款回收</span>
                        <span @click="showAlert = false" class="iconfont xuanzhuan">&#xe602;</span>
                    </div>
                    <!-- 图表2 -->
                    <div id="mainTwo"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
import utils from '@/assets/js/utils';
export default {
    data() {
        return {
            selectTimeYear: '',
            selectTimeMonth: '',
            orgId: '',
            yszkjs: 0,
            showAlert: false,
            showPickerTime: false,
            currentDate: new Date(),
            maxDate: '',
            daikuanVal: 0,
            totalMonth: 0,
            // 数据请求
            totalInfoData: {},
            totalDetailInfosData: {},
            payTotalInfoData: {},
            xListArr: [],
            yListArr: [],
            bnljhk: 0,
            bnjhhk: 0,
            jhwcl: 0,
            monthTwo: [],
            masterTwo: [],
            huishouTwo: [],
            salesTwo: [],
        };
    },
    created() {
        const obj = utils.getPreMon();
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
    },
    mounted() {
        this.selectTimeYear = this.$route.query.year;
        this.selectTimeMonth = this.$route.query.month;
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        this.getPayback();
    },
    methods: {
        getNewOrgId(value) {
            this.orgId = value;
            this.getPayback();
        },
        showChars() {
            this.getPaybackRate();
        },
        // 时间选择
        selectTime(value) {
            this.yListArr = [];
            this.selectTimeYear = this.timeFormat(value, 'year');
            this.selectTimeMonth = this.timeFormat(value, 'month');
            this.showPickerTime = false;
            this.getPayback();
        },
        // 拉取月度回款信息
        getPayback() {
            this.totalInfoData = {};
            this.totalDetailInfosData = {};
            this.xListArr = [];
            this.yListArr = [];
            this.yszkjs = 0;
            this.$axios
                .get(`/interfaceApi/report/FlowToManager/get_payback/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get(`/interfaceApi/report/FlowToManager/get_payback/2019/3/${this.orgId}`)
                .then(res => {
                    this.totalInfoData = res.totalInfo;
                    this.totalDetailInfosData = res.totalDetailInfos;
                    this.totalMonth = res.totalDetailInfos[1].value;
                    this.daikuanVal = res.totalDetailInfos[0].value * 100;
                    this.jhwcl = res.totalDetailInfos[1].plan_year_finish;
                    this.bnljhk = res.totalDetailInfos[1].sales_year;
                    this.bnjhhk = res.totalDetailInfos[1].plan_year;
                    this.yszkjs = Number(this.totalInfoData.advance_begin - this.totalInfoData.advance_end).toFixed(2);
                    if (this.totalDetailInfosData.length > 0) {
                        this.totalDetailInfosData.forEach((item, index) => {
                            if (index > 1) {
                                let newArr = [];
                                if (item.value) {
                                    newArr = item.value.toFixed(2);
                                } else {
                                    newArr = 0;
                                }
                                this.xListArr.push(item.type_name);
                                this.yListArr.push(newArr);
                            }
                        });
                        // eslint-disable-next-line max-len
                        Promise.all([this.xListArr, this.yListArr]).then(() => {
                            setTimeout(() => {
                                this.topChart();
                            }, 100);
                        }).catch(error => {
                            Dialog({ message: error.Errorcode.Message });
                        });
                    } else {
                        this.yListArr = [];
                    }
                })
                .catch(() => {
                });
        },
        // 拉取回款率信息
        getPaybackRate() {
            this.monthTwo = [];
            this.huishouTwo = [];
            this.masterTwo = [];
            this.salesTwo = [];
            this.$axios
                .get(`/interfaceApi/report/FlowToManager/get_payback_rate/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                .then(res => {
                    this.payTotalInfoData = res;
                    res.forEach(item => {
                        let arr;
                        if (item.payback) {
                            arr = Number(item.payback.toFixed(2));
                        } else {
                            arr = 0;
                        }
                        let brr;
                        if (item.sales) {
                            brr = Number(item.sales.toFixed(2));
                        } else {
                            brr = 0;
                        }
                        let crr;
                        if (item.payback_rate) {
                            crr = Number((item.payback_rate * 100).toFixed(2));
                        } else {
                            crr = 0;
                        }
                        this.monthTwo.push(item.month);
                        this.huishouTwo.push(brr || 0);
                        this.masterTwo.push(arr || 0);
                        this.salesTwo.push(crr || 0);
                    });
                    // eslint-disable-next-line max-len
                    Promise.all([this.monthTwo, this.huishouTwo, this.masterTwo, this.salesTwo]).then(() => {
                        this.showAlert = true;
                        setTimeout(() => {
                            this.threeTable();
                        });
                    }).catch(error => {
                        Dialog({ message: error.Errorcode.Message });
                    });
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 格式化日期
        timeFormat(date, status, upMonth) {
            const y = date.getFullYear(); // 年
            let m = date.getMonth() + 1; // 月
            let d = date.getDate(); // 日
            m = m > 9 ? m : '0' + m;
            d = d > 9 ? d : '0' + d;
            if (status === 'year') {
                return y;
            } if (status === 'month') {
                if (upMonth === 'upMonth') {
                    return m - 1;
                }
                return m;

            } if (status === 'day') {
                return d;
            }
            return `${y}-${m}-${d}`;
        },
        // 图表1
        topChart() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('main'));
            // 指定图表的配置项和数据
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        animation: true,
                    },
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.xListArr,
                        axisPointer: {
                            type: 'shadow',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '单位(万元)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        data: this.yListArr,
                        barWidth: 20, // 柱图宽度
                        // 配置样式
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    const colorList = ['#5588F1', '#EB656F', '#21BDCC', '#FA8436'];
                                    return colorList[params.dataIndex];
                                },
                            },
                        },
                        label: {
                            show: true,
                            position: 'top',
                        },
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        threeTable() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('mainTwo'));
            // 指定图表的配置项和数据
            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{a0}:{c0}<br />{a1}:{c1}<br />{a2}:{c2}%',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                legend: {
                    data: ['主收', '回款', '回收率'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.monthTwo,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(万元)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置name边距
                        nameTextStyle: {
                            padding: [60, 0, 0, 0], // 四个数字分别为上右下左与原位置距离
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '回收率(%)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        nameTextStyle: {
                            padding: [0, 0, 0, -60], // 四个数字分别为上右下左与原位置距离
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '主收',
                        type: 'bar',
                        data: this.huishouTwo,
                        color: '#5588F1',
                    },
                    {
                        name: '回款',
                        type: 'bar',
                        data: this.masterTwo,
                        color: '#FA8436',
                    },
                    {
                        name: '回收率',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.salesTwo,
                        color: '#C64FDF',
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
    },
    components: {
        HeaderNav,
    },
};
</script>
<style lang='stylus' scoped>
.hkqk-view
    padding-top 74rpx
    height calc(100% - 74rpx)
#main
    width 100%
    height 240rpx
    background #fff
.money-back-box
    overflow-y scroll
    overflow-x hidden
    height 100%
    padding-bottom 74rpx
.picker-content
    position fixed
    width: 100%;
    z-index 9
    height: 100%;
    background: rgba(0, 0, 0, .4);
    top: 0
    z-index 999
.van-picker
    position fixed;
    bottom 0;
    width 100%;
.head-title-tips
    width 100%
    height 30rpx
    background #F0F0F0
    font-size 12rpx
    text-align center
    line-height 30rpx
    position fixed
    top 44rpx
    .iconrili
        font-size 18rpx
        margin-right 6rpx
        cursor pointer
        color: #5588F1;
.mobile-one
    width 100%
    padding 15rpx
    border-bottom 15rpx solid #F0F0F0
    .mobile-one-title
        width 100%
        display flex
        justify-content space-between
        margin-bottom 15rpx
        p:first-child
            color #333333
            font-size 16rpx
            font-weight 700
            span
                color #E56477
        p:last-child
            width 140rpx
            height 25rpx
            border-radius 4rpx
            background #5588F1
            color #ffffff
            text-align center
            line-height 25rpx
            font-size 10rpx
            font-weight 600
    .mobild-one-bottom
        display flex
        justify-content center
        align-items center
        div
            display flex
            flex-direction column
            justofy-content center
            align-items center
            &:nth-child(1)
                margin-right 20rpx
                p
                    color #21BDCC
            &:nth-child(3)
                margin 0 15rpx
                p
                    color #EB656F
            &:nth-child(5)
                margin-left 20rpx
                p
                    color #5588F1
            p
                font-size 16rpx
            span
                font-size 10rpx
                color #666666
        .shu
            width 1px
            height 15rpx
            background #EAEAEA

.mobile-two
    width 100%
    padding 15rpx
    border-bottom 15rpx solid #F0F0F0
    h2
        display flex
        justify-content space-between;
        align-items center;
        color #333333
        font-size 16rpx
        font-weight 700
        span
            color #979EA7
            font-size 10rpx
    .big-block
        display flex
        justify-content space-between
        margin-top 15rpx
        .color-block
            width 105rpx
            height 40rpx
            position relative
            display flex
            justify-content center
            align-items center
            overflow hidden
            &:nth-child(1)
                border 1px solid #22BCCF
                background #eefcfe
                p
                    color #22BCCF
                h3
                    border-color:transparent transparent transparent #22BCCF;
            &:nth-child(2)
                border 1px solid #FF7E00
                background #FFF7F5
                p
                    color #FF7E00
                h3
                    border-color:transparent transparent transparent #FF7E00;
            &:nth-child(3)
                border 1px solid #5588F1
                background #F3F9FE
                p
                    color #5588F1
                h3
                    border-color:transparent transparent transparent #5588F1;
            p
                position absolute
                font-size 16rpx
            span
                position absolute
                color #FFFFFF
                font-size 6rpx
                z-index 3
                right -2rpx
                top 3rpx
                transform rotate(50deg)
            h3
                width:0;
                height:0;
                border-width:0 0 25rpx 25rpx;
                border-style:solid;
                position:absolute;
                transform rotate(90deg)
                right 0
                top 0
.mobile-three
    width 100%
    padding 15rpx
    h2
        display flex
        justify-content space-between;
        align-items center;
        color #333333
        font-size 16rpx
        font-weight 700
        span
            color #979EA7
            font-size 10rpx
    .mobild-three-content
        display flex
        justify-content space-between
        flex-wrap wrap
        .mobile-content
            width 105rpx
            height 50rpx
            border 1px solid #EAEAEA
            display flex
            flex-direction column
            justify-content center
            margin-top 15rpx
            span
                color #666666
                font-size 10rpx
                margin-left 14rpx
            p
                font-size 16rpx
                margin-left 14rpx
                font-family 800
            .green-color
                color #21BDCC
            .origin-color
                color #FA8436
            .blue-color
                color #5588F1
.alert-chart
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0,0,0, 0.4);
    z-index 999
    display flex
    justify-content center
    align-items center
    #mainTwo
        width 90%
        height 300rpx
        margin 0 5%
    .chart-content
        min-width 90%
        min-height 300rpx
        background #FFFFFF
        .content-title
            display flex
            padding 0 15rpx
            justify-content space-between
            align-items center
            height 40rpx
            background #F0F0F0
            .title-center
                color #333333
                font-size 14rpx
                font-weight 700
            .xuanzhuan
                transform rotate(45deg)
</style>